export const beautifyLongNumber = (
  value: string | number = '',
  notation: 'compact' | 'standard' = 'compact',
  maximumFractionDigits = 1
): string => {
  if (value === null || value === undefined) {
    return ''
  }

  return new Intl.NumberFormat('en-US', {
    notation,
    maximumFractionDigits,
  }).format(parseInt(value.toString()))
}

export function randIntFromInterval(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function randFromRange(items: any[]) {
  return items[Math.floor(Math.random() * items.length)]
}

export function uuidv4() {
  return (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (s) => {
    const c = +s
    return (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  })
}

export function noop() {}

export async function hashData(data: string, algorithm = 'SHA-256') {
  const encoder = new TextEncoder()
  const dataBuffer = encoder.encode(data)
  const hashBuffer = await crypto.subtle.digest(algorithm, dataBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export function base64Decode(input: string): string {
  try {
    const decoded = atob(input)

    return decodeURIComponent(
      Array.prototype.map
        .call(
          decoded,
          (c: string) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')
        )
        .join('')
    )
  } catch (e) {
    throw new Error('Invalid Base64 input')
  }
}
